import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_NextUseInformation = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Next-Use Information"
    videos={[
      "https://www.youtube.com/embed/Cm-2pUt6p5g",
      "https://www.youtube.com/embed/0VywQeCQ9c8",
    ]}
    takeaways={[]}
    questions={[
      "Analyze the role of next-use information in optimizing register usage during code generation. How does the next-use information help in determining which values should be kept in registers and which should be spilled? Provide an example to explain your analysis."
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_NextUseInformation;
